import { z } from "zod";

// Regex for Saudi mobile numbers: starts with 05 or +9665 and followed by 8 digits
const saudiPhoneRegex = /^((\+966)|0)?5\d{8}$/;

export const addOrgSchema = z.object({
  // شعار المؤسسة (صورة)
  logo: z.instanceof(File).optional(),

  // ── الخطوة الأولى ──────────────────────
  name: z.string().min(2, "يجب أن يحتوي الاسم على حرفين على الأقل"),
  code: z.string().min(2, "يجب أن يحتوي الرمز على حرفين على الأقل"),
  fees: z.string().min(1, "الرجاء إدخال مبلغ"),
  websiteUrl: z.string().url("الرابط غير صالح، الرجاء إدخال رابط صحيح"),
  description: z.string().max(500, "الوصف يجب ألا يتجاوز 500 حرف").optional(),

  // ── الخطوة الثانية ──────────────────────
  adminName: z.string().min(2, "يجب أن يحتوي اسم المسؤول على حرفين على الأقل"),
  email: z.string().email("يرجى إدخال بريد إلكتروني صالح"),
  mobile: z.string().regex(saudiPhoneRegex, "يرجى إدخال رقم جوال سعودي صالح"),
});

export type AddOrgFormData = z.infer<typeof addOrgSchema>;
